module.exports = __webpack_public_path__ + "img/iconhome.b64d2fe2.svg";